<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 600px; max-width: 100vw;':''">
    <q-card-section class="no-padding">
      <q-banner inline-actions class="bg-indigo text-white">
        <div>
          لیست حواله های رزرو
        </div>
        <div>
          {{ goodsInfo.Goods_Name }}
          <q-badge align="top" color="red" text-color="white" :label="goodsInfo.Goods_Code"/>
        </div>
        <template v-slot:action>
          <q-btn flat icon="close" round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <q-card flat v-for="havaItem in lodash.orderBy(items,['State_Name','City_Name','Cs_Name','Sale_Num'])"
              :key="havaItem.Sale_Num">
        <q-card-section class="no-padding" :horizontal="!$q.screen.lt.md">
          <q-chip dense square color="indigo" text-color="white" :label="havaItem.Sale_Num" clickable
                  @click="showHavaDetails(havaItem.Sale_Num)"
                  icon="pin">
            <q-badge class="q-ml-sm" color="red" text-color="white" :label="havaItem.GoEvent_StOut"/>
          </q-chip>
          <q-chip dense square :label="havaItem.StorName" icon="store"/>
          <q-chip dense square :label="havaItem.Cs_Name" clickable @click="getCustomerInfo(havaItem.Cs_ID)"
                  icon="pin"/>
          <q-space/>
          <q-chip dense square :label="havaItem.State_Name" icon="location_city"/>
          <q-chip dense square :label="havaItem.City_Name" icon="location_city"/>
          <q-separator color="teal"/>
        </q-card-section>
      </q-card>
    </q-card-section>

    <q-dialog
        maximized
        v-model="showHavaDetailsDialog">
      <HavaDetails :store_id="[1,2,3,4,5]" :sale-kind="1" :hava_num="selectedHavaNum"/>
    </q-dialog>

    <q-dialog v-model="customerInfoDialog" :maximized="$q.screen.lt.md">
      <CustomerInfo :selected-customer="selectedCustomer"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import HavaDetails from "@/components/customers/HavaDetails";
import CustomerInfo from "@/components/customers/CustomerInfo";

export default {
  name: "ReserveExiList",
  components: {CustomerInfo, HavaDetails},
  props: {
    goodsInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      items: [],
      selectedCustomer: '',
      selectedHavaNum: '',
      customerInfoDialog: false,
      showHavaDetailsDialog: false
    }
  },
  methods: {
    ...mapActions({
      getReserveExiWithGoodsID: 'Products/getReserveExiWithGoodsID',
      setCustomerInfo: 'Customers/get_customer_info',
    }),
    getCustomerInfo(id) {
      this.setCustomerInfo(id).then((res) => {
        this.selectedCustomer = res.data[0]
        this.customerInfoDialog = true
      })
    },
    showHavaDetails(Hava_Num) {
      this.selectedHavaNum = Hava_Num
      this.showHavaDetailsDialog = true;
    },
  },
  created() {
    this.getReserveExiWithGoodsID(this.goodsInfo.Goods_ID).then((res) => {
      this.items = res
    })
  }
}
</script>

<style scoped>

</style>